import { useState } from 'react'
import { useAudioPlayer } from './provider'
import { Pause, PlayArrow, QueueMusic, SkipNext, SkipPrevious } from '@nine-thirty-five/material-symbols-react/sharp/filled'
import { Card, CardMedia, IconButton, Link, Slider, Typography } from '@iziplay/ui-kit'
import { MarqueeText } from '../marqueeText'

export const AudioPlayer = () => {
  const { currentTrack, play, pause, back, next, setTrackPosition, playing, percent } = useAudioPlayer()
  const [hovered, setHovered] = useState(false)
  return (
    <Card
      style={{ display: 'flex' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ display: 'flex', flexDirection: 'column', padding: 16, minWidth: 0, flex: 1 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <CardMedia
            style={{ height: 40, width: 40, marginBottom: 10 }}
            image={currentTrack && `${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${currentTrack?.artist.id}/release/${currentTrack?.release.id}/artwork?size=80`}
            title={currentTrack && `Cover of ${currentTrack.release.name} by ${currentTrack.artist.name}`}
          />
          <Link to="/music/playlist" style={{ color: 'inherit' }}>
            <IconButton aria-label="playlist">
              <QueueMusic size={20} />
            </IconButton>
          </Link>
        </div>
        <Typography variant="subtitle1">
          <MarqueeText text={currentTrack?.name ?? '-'} hovered={hovered} />
        </Typography>
        <Link variant="subtitle2" color="textSecondary" to={`/music/${currentTrack?.artist.id}`} underline="hover" style={{ marginBottom: 12, minWidth: 0 }}>
          <MarqueeText text={currentTrack?.artist.name ?? '-'} hovered={hovered} />
        </Link>
        <Slider
          size="small"
          value={percent * 100}
          onChange={value => setTrackPosition(value / 100)}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <IconButton
            aria-label="previous"
            onClick={() => {
              back()
            }}
          >
            <SkipPrevious size={24} />
          </IconButton>
          <IconButton
            aria-label="play/pause"
            onClick={() => {
              if (playing) {
                return pause()
              }
              play()
            }}
          >
            {playing ? <Pause size={38} /> : <PlayArrow size={38} />}
          </IconButton>
          <IconButton
            aria-label="next"
            onClick={() => {
              next()
            }}
          >
            <SkipNext size={24} />
          </IconButton>
        </div>
      </div>
    </Card>
  )
}
